<template>
  <v-container>
    <v-list>
      <ReportItem
        v-for="(report, index) in reports"
        v-bind:key="index"
        :report="report"
        :id="personId"
      >
      </ReportItem>
    </v-list>
  </v-container>
</template>

<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper";
import ReportItem from "@/components/ReportItem";

export default defineComponent({
  name: "PersonReport",
  components: { ReportItem },
  props: {
    id: { type: String },
  },
  computed: {
    personId() {
      return Number.parseInt(this.id);
    },
  },
  data() {
    return {
      reports: [],
    };
  },
  async created() {
    this.reports = await this.apiList({
      resource: "app/report",
      query: "type=course",
    });
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
